import type { FC, ReactNode } from 'react';

import { useProfileModeration } from 'hooks/useProfileModeration';
import { TutorAccessClosed } from 'modules/Teacher/components/TutorAccessClosed';

import classes from './VerifiedAccountGuard.module.scss';
import { BrandLoader } from 'ui/BrandLoader/BrandLoader';

type Props = {
  children: ReactNode;
  editPath: string;
};

export const VerifiedAccountGuard: FC<Props> = ({ children, editPath }) => {
  const { isLoading, isApproved } = useProfileModeration();

  if (editPath.startsWith('/profile')) {
    return <>{children}</>;
  }

  if (isLoading) {
    return (
      <div className={classes.locked}>
        <BrandLoader center label='Загрузка...' />
      </div>
    );
  }

  if (!isApproved) {
    return <TutorAccessClosed />;
  }

  return children;
};
